import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import api from '../sever/Api';

const UserProfileMini = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [me, setMe] = useState(null);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await api.get('/api/user/me');
        setMe(res.data?.user || null);
      } catch (e) {
        setError('Failed to load user');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className='flex flex-col lg:flex-row min-h-screen w-full overflow-x-hidden'>
      <div className="fixed top-0 left-0 h-screen w-64 bg-white shadow-md z-10">
        <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      </div>
      <div className='ml-64 flex-1 relative'>
        <Navbar toggleSidebar={toggleSidebar} />
        <div className="min-h-screen w-full overflow-x-hidden bg-gradient-to-br from-[#EFF6FF] via-white to-[#F9FAFB]">
          <div className="w-full max-w-3xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">My Account</h1>
            {loading ? (
              <div>Loading...</div>
            ) : error ? (
              <div className="text-red-600 text-sm">{error}</div>
            ) : me ? (
              <div className="bg-white border rounded p-4">
                <div className="text-sm text-gray-600">User ID</div>
                <div className="mb-2">{me._id}</div>
                <div className="text-sm text-gray-600">Name</div>
                <div className="mb-2">{me.name}</div>
                <div className="text-sm text-gray-600">Email</div>
                <div className="mb-2">{me.email}</div>
                <div className="text-sm text-gray-600">Role</div>
                <div className="mb-2">{me.role}</div>
              </div>
            ) : (
              <div>No data</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileMini;


